import {
  CLEAR_COMPARISON_NOTIFICATION,
  SET_COMPARISON_NOTIFICATION,
} from '../../constants/actionTypes/offersComparison';
import { IComparisonNotification } from '../../types/offersComparion';
import { TReduxActions } from '../../types/redux';

const defaultState = null;

export function comparisonNotificationReducer(
  state: IComparisonNotification | null = defaultState,
  action: TReduxActions,
) {
  switch (action.type) {
    case SET_COMPARISON_NOTIFICATION:
      return {
        ...state,
        text: action.text,
        url: action.url,
        category: action.category,
        offerId: action.offerId,
      };
    case CLEAR_COMPARISON_NOTIFICATION:
    default:
      return null;
  }
}
